import { render, staticRenderFns } from "./AboutusInfo.vue?vue&type=template&id=33aa7a0d&"
import script from "./AboutusInfo.vue?vue&type=script&lang=js&"
export * from "./AboutusInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports